export default __webpack_public_path__ + "static/media/Intimation of Board Meeting.a8ce128b.pdf";